import { LoadingService } from 'src/app/core/shared/services/loading.service';
import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {MessageErrorResolver} from "../../utilities/message-error-resolver";
import {catchError, EMPTY, finalize, map, Observable} from "rxjs";
import {IPage} from "../../models/pagination/page";
import {ICityDto} from "../../models/city-dto";
import {ResponseDto, ResponseWithErrorDto} from "../../models/exceptions/response-dto";
import {IStateDto} from "../../models/state-dto";
import { StateFilter } from '@modules/states/list-states/list-states.component';
import { toParams } from '../../utilities/utility-functions';
import { PageRequest } from '@models/pagination/page-request';
import { StatesPostForm } from '@modules/states/edit-states/form/states-post-form';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  private url: string = environment.apiUrl + "/v1/estados";

  constructor(
    private httpClient: HttpClient,
    private messageErrorResolver: MessageErrorResolver,
    private loadingService: LoadingService
  ) {}

  public getAllStates(page?: number, size?: number): Observable<IPage<IStateDto>> {
    let params = new HttpParams();
    if (page) params = params.set("page", page);
    if (size) params = params.set("size", size);
    return this.httpClient.get<ResponseDto<IPage<IStateDto>>>(this.url, {params})
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.messageErrorResolver.resolveMessage(error);
          this.loadingService.deactivate();
          return EMPTY;
        })
      );
  }

  public getAllCitiesByStateId(estNrId: number, page?: number, size?: number): Observable<IPage<ICityDto>> {
    let params = new HttpParams();

    if (page) params = params.set("page", page);
    if (size) params = params.set("size", size);

    return this.httpClient.get<ResponseDto<IPage<ICityDto>>>(this.url + `/${estNrId}/cidades`, {params})
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        })
      );
  }

  public getStateById(estNrId: number): Observable<IStateDto> {
    let params = new HttpParams();
    params.set("estNrId", estNrId);
    return this.httpClient.get<ResponseDto<IStateDto>>(this.url + `/${estNrId}`, {params})
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        })
      );
  }

  public getAllStatesByFilter(page?:PageRequest,filter?: StateFilter):Observable<IPage<IStateDto>> {

    const params = toParams(filter,page)

    return this.httpClient.get<ResponseDto<IPage<IStateDto>>>(this.url + `/filtrar`, { params })
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        })
      );

  }


  public updateState(form: StatesPostForm): Observable<IStateDto> {
    return this.httpClient.post<ResponseDto<IStateDto>>(this.url,form)
      .pipe(
        finalize(()=>this.loadingService.deactivate()),
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        })
      );
  }


  public deleteStateById(estNrId:number):Observable<void>{
    return this.httpClient.delete<ResponseDto<void>>(this.url +`/${estNrId}`)
       .pipe(map(() => undefined));
  }
}
